export default __webpack_public_path__ + "static/media/header-back.681eea2b.jpg";